/**
 * Created by pbo on 21/04/16.
 */

angular.module('taric.model.cd', ['common.helper', 'ngResource']).factory('CalculateDuty', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/cd/commodity/declarable', {}, {
        isCommodityCodeDeclarable: {
            method: 'GET',
            isArray: false
        },
        getPreferenceCodesAndSupplementaryUnit: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/selectionsBasedOnCommodityAndCountry'
        },
        getQuotaOrderNumbersAndRequiredCountryOfDispatch: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/selectionsBasedOnPreferenceCode'
        },
        getQuotaOrderNumbersAndRequiredCountryOfDispatchSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/selectionsBasedOnPreferenceCode'
        },
        getMeasurementUnits: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/measurementUnits'
        },
        isAllowedEndUseProcedureCode: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/isAllowedEndUseProcedureCode'
        },
        isAllowedEndUseProcedureCodeSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/isAllowedEndUseProcedureCode'
        },
        getAdditionalCodes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/additionalCodes'
        },
        getAdditionalCodesSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/additionalCodes'
        },
        getOptionalAdditionalCodes: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/optionalAdditionalCodes'
        },
        getDocuments: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/documents'
        },
        getResults: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/cd/calculationResult'
        },
        getResultsSecure: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/secure/cd/calculationResult'
        }
    });
}).service('CalculateDutyModel', function ($q, CalculateDuty, CommonHelper, CONSTANTS, $translate, $timeout, AuthorizeModel, $rootScope) {
    var model = this;
    var calculationInput = {
        language: CommonHelper.getLanguageCode($translate.use()),
        simulationDate: new Date(),
        commodityCode: '',
        tradeDirection: 'I',
        customsValue: null,
        netWeight: null,
        country: null,
        countryOfDispatch: null,
        preferenceCode: null,
        supplementaryUnitValue: null,
        quotaOrderNumber: null,
        useCurrentQuotaStatus: false,
        customsValueCurrency: CONSTANTS.installationCurrency,
        dutyCurrency: CONSTANTS.installationCurrency,
        measurementUnits: null,
        additionalCodes: null,
        documents: null,
        expandAll: false,
        countryOfPreferentialOrigin: null,
        version: 'UCC'
    };
    var calculationResult = null;

    model.tabRendering = {};
    model.lastRestSimulationDate = null;
    model.countriesAndRegions = {count: 0, items: []};
    model.customsValueMonetaryUnits = {count: 0, items: []};
    model.dutyMonetaryUnits = {count: 0, items: []};
    model.preferenceCodesAndSupplementaryUnit = {preferenceCodes: {count: 0, items: []}};
    model.quotaOrderNumbersAndRequiredCountryOfDispatch = {"quotaOrderNumbers": [], "countryOfDispatchRequired": false};
    model.quotaOrderNumbersEnabled = false;
    model.countryOfDispatchEnabled = false;
    model.countryOfDispatchObject = null;
    model.measurementUnits = null;
    model.documents = null;
    model.meursingAdditionalCode = null;

    $rootScope.$on('clearSearchResult', function(event, data) {
        model.reset();
    });
    
    model.calculationResult = function () {
        return calculationResult;
    };
    model.resetCalculationResult = function () {
        calculationResult = null;
    };
    model.getCalculationInput = function () {
        return calculationInput;
    };
    model.getCalculationResult = function () {
        return calculationResult;
    };
    model.setSimulationDate = function (simulationDate) {
        var newDate = CommonHelper.getRestDateString(simulationDate);
        if (newDate !== model.lastRestSimulationDate) {
            calculationInput.simulationDate = simulationDate;
            model.reset();
        }
        model.lastRestSimulationDate = newDate;
    };
    model.setCommodityCode = function (commodityCode) {
        var res = CommonHelper.removeSpaceCharacters(commodityCode);
        if (res !== calculationInput.commodityCode) {
            model.reset();
            calculationInput.commodityCode = res;
        }
    };

    model.reset = function () {
        model.countriesAndRegions = {count: 0, items: []};
        model.customsValueMonetaryUnits = {count: 0, items: []};
        model.dutyMonetaryUnits = {count: 0, items: []};

        model.tabRendering = {
            activeIndex: 0,
            commodity: {
                disabled: false,
                index: 0
            },
            data: {
                disabled: true,
                index: 1
            },
            additionalCodes: {
                disabled: true,
                index: 2
            },
            documents: {
                disabled: true,
                index: 3
            },
            units: {
                disabled: true,
                index: 4
            },
            security: {
                disabled: true,
                index: 5
            },
            results: {
                disabled: true,
                index: 6
            }
        };
        model.updateCalculationSupportVersion();
        model.resetDataTab();
        model.resetAdditionalCodesTab();
        model.resetMeasurementUnitsTab();
        model.resetDocumentsTab();
        model.resetSecurityTab();
        model.resetResultsTab();

        if (CONSTANTS.releaseManagement) {
            model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
        } else {
            model.includeUnreleased = false;
        }
        model.loggedIn = AuthorizeModel.loggedIn;
    };

    model.resetDataTab = function () {
        calculationInput.customsValue = null;
        calculationInput.netWeight = null;
        calculationInput.country = null;
        calculationInput.countryOfPreferentialOrigin = null;
        calculationInput.procedureCode = null;
        calculationInput.countryOfDispatch = null;
        calculationInput.preferenceCode = null;
        calculationInput.supplementaryUnitValue = null;
        calculationInput.quotaOrderNumber = null;
        calculationInput.useCurrentQuotaStatus = false;
        calculationInput.customsValueCurrency = CONSTANTS.installationCurrency;
        calculationInput.dutyCurrency = CONSTANTS.installationCurrency;                
        model.preferenceCodesAndSupplementaryUnit = {preferenceCodes: {count: 0, items: []}};
        model.quotaOrderNumbersAndRequiredCountryOfDispatch = {
            "quotaOrderNumbers": [],
            "countryOfDispatchRequired": false
        };
        model.quotaOrderNumbersEnabled = false;
        model.countryOfDispatchEnabled = false;
        model.countryOfDispatchInfoText = null;
    };

    model.updateCalculationSupportVersion = function() {
        calculationInput.version = 'UCC';
        const uccApplicableDate = moment(CONSTANTS.uccApplicableDate, CONSTANTS.dateFormat.toUpperCase(), true).toDate();
        if (CommonHelper.compareDatesWithoutTime(calculationInput.simulationDate, uccApplicableDate) < 0) {
            calculationInput.version = 'PRE_UCC';
        } else {
            if (CONSTANTS.supportedCalculationVersions.length === 1){
                calculationInput.version = CONSTANTS.supportedCalculationVersions[0];
            }
        }
    };

    model.resetAdditionalCodesTab = function () {
        calculationInput.meursing = null;
        calculationInput.additionalCodes = null;
        calculationInput.optionalAdco = "";
        calculationInput.meursing = null;
        calculationInput.exportRefundAdco = "";
        model.tabRendering.additionalCodes.disabled = true;
        model.additionalCodes = null;
        model.optionalAdditionalCodes = null;
    };

    model.resetMeasurementUnitsTab = function () {
        calculationInput.measurementUnits = null;
        model.measurementUnits = null;
        model.tabRendering.units.disabled = true;
    };

    model.resetSecurityTab = function () {
        model.quotaSecurities = [];
        if (model.calculationInput){
            model.calculationInput.selectedQuotaSecurity = null;
        }
        model.tabRendering.security.disabled = true;
    };

    model.resetDocumentsTab = function () {
        calculationInput.documents = null;
        model.documents = null;
        model.tabRendering.documents.disabled = true;
    };

    model.resetResultsTab = function() {
        model.noAmounts = [];
        model.noSummary = null;
        model.noSecAmounts = [];
        model.sivAmounts = [];
        model.sivSummary = null;
        model.sivSecAmounts = [];
        model.uvAmounts = [];
        model.uvSummary = null;
        model.uvSecAmounts = [];
        model.calculationMeasures = [];
        model.calculationsTabsEnabled = false;
        model.installationCountry = CONSTANTS.installationCountry;
    };

    model.initializeCalculateDuty = function () {
        model.reset();
        calculationInput.language = CommonHelper.getLanguageCode($translate.use());
        calculationInput.simulationDate = new Date();
        model.lastRestSimulationDate = CommonHelper.getRestDateString(calculationInput.simulationDate);
        calculationInput.commodityCode = '';
        calculationInput.tradeDirection = 'I';
    };

    model.isCommodityCodeDeclarable = function (commodityCode, simulationDate, tradeDirection) {
        var deferred = $q.defer();
        CalculateDuty.isCommodityCodeDeclarable({
            commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
            simulationdate: CommonHelper.getRestDateString(simulationDate),
            tradedirection: tradeDirection
        }, function (result) {
            deferred.resolve(result.declarable);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getQuotaOrderNumbersAndRequiredCountryOfDispatch = function (tradeDirection, commodityCode, country, preferenceCode, simulationDate, countryOfPreferentialOrigin, version) {
        var deferred = $q.defer();
        if (model.loggedIn) {
            CalculateDuty.getQuotaOrderNumbersAndRequiredCountryOfDispatchSecure({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                country: country,
                preferencecode: preferenceCode,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin,
                version
            }, function (resultSecure) {
                deferred.resolve(resultSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getQuotaOrderNumbersAndRequiredCountryOfDispatch({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                country: country,
                preferencecode: preferenceCode,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin,
                version
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

    };

    model.getPreferenceCodesAndSupplementaryUnit = function (commodityCode, country, simulationDate, tradeDirection, countryOfPreferentialOrigin, version) {
        var deferred = $q.defer();
        if (model.loggedIn) {
            CalculateDuty.getPreferenceCodesAndSupplementaryUnit({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin,
                version
            }, function (resultSecure) {
                deferred.resolve(resultSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getPreferenceCodesAndSupplementaryUnit({
                commoditycode: CommonHelper.removeSpaceCharacters(commodityCode),
                country: country,
                simulationdate: CommonHelper.getRestDateString(simulationDate),
                tradedirection: tradeDirection,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin,
                version
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.loadMeasurementUnits = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        CalculateDuty.getMeasurementUnits({
            commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
            country: calculationInput.country,
            countryofdispatch: calculationInput.countryOfDispatch,
            simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
            tradedirection: calculationInput.tradeDirection,
            preferencecode: calculationInput.preferenceCode,
            additionalcodes: calculationInput.additionalCodes,
            netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
            customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
            customsvalueMonetaryunit: calculationInput.customsValueCurrency,
            dutyamountMonetaryunit: calculationInput.dutyCurrency,
            supplementaryunit: suppUnit,
            ordernumber: calculationInput.quotaOrderNumber,
            documents: calculationInput.documents,
            countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
            version: calculationInput.version,
            procedureCode: calculationInput.procedureCode,
            includeUnreleased: model.includeUnreleased
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.loadAdditionalCodes = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        if (model.loggedIn) {
            CalculateDuty.getAdditionalCodesSecure({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode,
                includeUnreleased: model.includeUnreleased
            }, function (resultSecure) {
                model.additionalCodes = resultSecure;
                deferred.resolve(resultSecure);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getAdditionalCodes({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                model.additionalCodes = result;
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }

    };

     model.isAllowedEndUseProcedureCode = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        if (model.loggedIn) {
            CalculateDuty.isAllowedEndUseProcedureCodeSecure({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: false,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode,
                includeUnreleased: model.includeUnreleased
            }, function (resultSecure) {
                deferred.resolve(resultSecure.allowed);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.isAllowedEndUseProcedureCode({
                commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                country: calculationInput.country,
                countryofdispatch: calculationInput.countryOfDispatch,
                simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                tradedirection: calculationInput.tradeDirection,
                preferencecode: calculationInput.preferenceCode,
                netweight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                customsvalue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsvalueMonetaryunit: calculationInput.customsValueCurrency,
                dutyamountMonetaryunit: calculationInput.dutyCurrency,
                supplementaryunit: suppUnit,
                ordernumber: calculationInput.quotaOrderNumber,
                usecurrentquotastatus: calculationInput.useCurrentQuotaStatus,
                filterHiddenMeasureTypes: true,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                deferred.resolve(result.allowed);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
     };

    model.loadOptionalAdditionalCodes = function () {
        var deferred = $q.defer();
        CalculateDuty.getOptionalAdditionalCodes({
            simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate)
        }, function (result) {
            model.optionalAdditionalCodes = result;
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.loadDocuments = function () {
        var deferred = $q.defer();
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        CalculateDuty.getDocuments({
            simulationdate: CommonHelper.getRestDateString(calculationInput.simulationDate),
            commoditycode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
            tradedirection: calculationInput.tradeDirection,
            additionalcodes: calculationInput.additionalCodes,
            country: calculationInput.country,
            countryOfDispatch: calculationInput.countryOfDispatch,
            customsValue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
            customsValueMonetaryUnit: calculationInput.customsValueCurrency,
            netWeight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
            orderNumber: calculationInput.quotaOrderNumber,
            supplementaryUnit: suppUnit,
            preferencecode: calculationInput.preferenceCode,
            dutyamountMonetaryunit: calculationInput.dutyCurrency,
            useCurrentQuotaStatus: calculationInput.useCurrentQuotaStatus,
            countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
            version: calculationInput.version,
            procedureCode: calculationInput.procedureCode,
            includeUnreleased: model.includeUnreleased
        }, function (result) {
            model.documents = result;
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.loadResults = function () {
        var deferred = $q.defer();

        var measurementUnits = null;
        if (calculationInput.measurementUnits !== null) {
            measurementUnits = [];
            var str;
            for (let i = 0; i < calculationInput.measurementUnits.length; i++) {
                str = '';
                str = str.concat(calculationInput.measurementUnits[i].id, ':', CommonHelper.getDecimalNumber(calculationInput.measurementUnits[i].value));
                measurementUnits[i] = str;
            }
        }
        var suppUnit = null;
        if (calculationInput.supplementaryUnitValue !== null) {
            suppUnit = model.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id.concat(':', CommonHelper.getDecimalNumber(calculationInput.supplementaryUnitValue));
        }
        if (model.loggedIn) {
            CalculateDuty.getResultsSecure({
                simulationDate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                commodityCode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                tradeDirection: calculationInput.tradeDirection,
                additionalCodes: calculationInput.additionalCodes,
                documents: calculationInput.documents,
                country: calculationInput.country,
                countryOfDispatch: calculationInput.countryOfDispatch,
                customsValue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsValueMonetaryUnit: calculationInput.customsValueCurrency,
                netWeight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                orderNumber: calculationInput.quotaOrderNumber,
                supplementaryUnit: suppUnit,
                measurementUnits: measurementUnits,
                useCurrentQuotaStatus: calculationInput.useCurrentQuotaStatus,
                preferenceCode: calculationInput.preferenceCode,
                dutyAmountMonetaryUnit: calculationInput.dutyCurrency,
                includeUnreleased: model.includeUnreleased,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                calculationResult = result;
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            CalculateDuty.getResults({
                simulationDate: CommonHelper.getRestDateString(calculationInput.simulationDate),
                commodityCode: CommonHelper.removeSpaceCharacters(calculationInput.commodityCode),
                tradeDirection: calculationInput.tradeDirection,
                additionalCodes: calculationInput.additionalCodes,
                documents: calculationInput.documents,
                country: calculationInput.country,
                countryOfDispatch: calculationInput.countryOfDispatch,
                customsValue: CommonHelper.getDecimalNumber(calculationInput.customsValue),
                customsValueMonetaryUnit: calculationInput.customsValueCurrency,
                netWeight: CommonHelper.getDecimalNumber(calculationInput.netWeight),
                orderNumber: calculationInput.quotaOrderNumber,
                supplementaryUnit: suppUnit,
                measurementUnits: measurementUnits,
                useCurrentQuotaStatus: calculationInput.useCurrentQuotaStatus,
                preferenceCode: calculationInput.preferenceCode,
                dutyAmountMonetaryUnit: calculationInput.dutyCurrency,
                includeUnreleased: false,
                countryOfPreferentialOrigin: calculationInput.countryOfPreferentialOrigin,
                version: calculationInput.version,
                procedureCode: calculationInput.procedureCode
            }, function (result) {
                calculationResult = result;
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

    model.goToNextTab = function (currentTab) {
        var deferred = $q.defer();
        model.getNextTab(currentTab).then(function (nextTab) {
            model.handleTabVisibility(currentTab, nextTab);
        }, function (error) {
            if (error.data.code === 'i8n.bl.unauthenticated') {
                $rootScope.$broadcast('tokenInvalid');
            }
            deferred.reject(error);
        });
        return deferred.promise;
    };

    /**
     * Get the next tab from the current tab.
     * This method should be used only after all data in the current tab has been validated.
     *
     * @param currentTab The current tab
     */
    model.getNextTab = function (currentTab) {
        var deferred = $q.defer();
        switch(currentTab) {
            case 'commodity':
                deferred.resolve('data');
                break;
            case 'data':
                model.shouldGoToTabAdditionalCodes().then(function(result){
                    if(result){
                        deferred.resolve('additionalCodes');
                    } else {
                        model.getNextTab('additionalCodes').then(function(result){
                            deferred.resolve(result);
                        }, function(error){
                            deferred.reject(error);
                        });
                    }
                }, function(error){
                    deferred.reject(error);
                });
                break;
            case 'additionalCodes':
                model.shouldGoToTabDocuments().then(function(result){
                    if(result){
                        deferred.resolve('documents');
                    }else {
                        model.getNextTab('documents').then(function(result){
                            deferred.resolve(result);
                        }, function(error){
                            deferred.reject(error);
                        });
                    }
                }, function(error){
                    deferred.reject(error);
                });

                break;
            case 'documents':
                model.shouldGoToTabUnits().then(function(result){
                    if(result){
                        deferred.resolve('units');
                    }else {
                        model.getNextTab('units').then(function(result){
                            deferred.resolve(result);
                        }, function(error){
                            deferred.reject(error);
                        });
                    }
                }, function(error){
                    deferred.reject(error);
                });

                break;
            case 'units':
                model.shouldGoToTabSecurity().then(function(result){
                    if(result){
                        deferred.resolve('security');
                    }else {
                        model.getNextTab('security').then(function(result){
                            deferred.resolve(result);
                        }, function(error){
                            deferred.reject(error);
                        });
                    }
                }, function(error){
                    deferred.reject(error);
                });

                break;
            case 'security':
                model.shouldGoToTabResults().then(function (result) {
                    if (result) {
                        deferred.resolve('results');
                    } else {
                        model.getNextTab('results').then(function (result) {
                            deferred.resolve(result);
                        }, function (error) {
                            deferred.reject(error);
                        });
                    }
                }, function (error) {
                    deferred.reject(error);
                });

                break;
            default:

                //If there is no matching tab, stay at the current tab.
                deferred.resolve(currentTab);
                break;

        }
        return deferred.promise;
    };

    /**
     * Move to the next tab and therefore, make the current tab inactive
     * @param currentTab The current tab
     * @param nextTab The next tab
     */
    model.handleTabVisibility = function(currentTab, nextTab){
        model.tabRendering.activeIndex = model.tabRendering[nextTab].index;
        model.tabRendering[nextTab].disabled = false;
    };

    model.shouldGoToTabAdditionalCodes = function () {
        var deferred = $q.defer();

        //Reset previous data of additional codes tab before checking
        model.resetAdditionalCodesTab();
        model.loadAdditionalCodes().then(function(cdAdco){
            if (cdAdco.adcoGroups.length > 0 || cdAdco.meursingApplicable){
                deferred.resolve(true);
            } else if(CONSTANTS.showOptionalAdditionalCodes){
                model.loadOptionalAdditionalCodes().then(function(cdOptAdco){
                    if (cdOptAdco.items.length > 0 && calculationInput.tradeDirection === 'I'){
                        deferred.resolve(true);
                    } else {
                        deferred.resolve(false);
                    }
                }, function(error){
                    deferred.reject(error);
                });
            } else {
                deferred.resolve(false);
            }

        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabDocuments = function () {
        var deferred = $q.defer();

        //Reset previous data of documents tab before checking
        model.resetDocumentsTab();
        model.loadDocuments().then(function(result){
            if (result.items.length > 0){
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabUnits = function () {
        var deferred = $q.defer();

        //Reset previous data in the units tab before checking
        model.resetMeasurementUnitsTab();
        model.loadMeasurementUnits().then(function (result) {
            if (result.count > 0) {
                model.measurementUnits = [];
                for (let i = 0; i < result.count; i++) {
                    model.measurementUnits[i] = {
                        id: result.items[i].id,
                        descriptions: result.items[i].descriptions,
                        value: null
                    };
                }
                deferred.resolve(true);
            } else {
                deferred.resolve(false);
            }
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabSecurity = function () {
        var deferred = $q.defer();

        //Reset previous data in the security tab before checking
        model.resetSecurityTab();
        model.loadResults().then(function (result) {
            if (result.calculations !== null) {
                for (let i = 0; i < result.calculations.length; i++) {
                    var calculation = result.calculations[i];
                    if ((calculation.type === 'NO' || calculation.type === 'UV') && calculation.securityItems) {
                        var securitySize = calculation.securityItems.length;
                        for (let j = 0; j < securitySize; j++){
                            if (calculation.securityItems[j].securityType === 'QUOTA'){
                                model.quotaSecurities.push(calculation.securityItems[j]);
                            }
                        }
                    }
                }
            }

            if(!CONSTANTS.enableSecurityTab){
                deferred.resolve(false);
            } else {

                //Select the first quota security by default
                if (model.quotaSecurities.length >= 1){
                    calculationInput.selectedQuotaSecurity = model.quotaSecurities[0].measureSid + "";
                }

                if (model.quotaSecurities.length > 1 || (model.quotaSecurities.length === 1 && CONSTANTS.selectIfOneSecurityItem)){
                    deferred.resolve(true);
                } else {
                    deferred.resolve(false);
                }
            }
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.shouldGoToTabResults = function () {
        var deferred = $q.defer();

        //Reset the result tab
        model.resetResultsTab();
        model.updateCalculationResults(calculationResult);
        deferred.resolve(true);

        return deferred.promise;
    };

    model.updateCalculationResults = function(calculationResult){
        if (calculationResult.measures !== null && calculationResult.calculations !== null) {
            for (let i = 0; i < calculationResult.calculations.length; i++) {
                var calculation = calculationResult.calculations[i];
                if (calculation.type === 'NO') {
                    model.noAmounts = model.getAmounts(calculation.dutyItems);
                    model.noSummary = calculation.dutyItemsSummary;
                    model.noSecAmounts = model.getSecurityAmounts(calculation.securityItems);
                } else if (calculation.type === 'SIV') {
                    model.sivAmounts = model.getAmounts(calculation.dutyItems);
                    model.sivSummary = calculation.dutyItemsSummary;
                    model.sivSecAmounts = model.getSecurityAmounts(calculation.securityItems);
                } else if (calculation.type === 'UV') {
                    model.uvAmounts = model.getAmounts(calculation.dutyItems);
                    model.uvSummary = calculation.dutyItemsSummary;
                    model.uvSecAmounts = model.getSecurityAmounts(calculation.securityItems);
                }
            }
            model.calculationsTabsEnabled = !(model.sivAmounts.length === 0 && model.uvAmounts.length === 0);
            model.calculationMeasures = [];
            for (let i = 0; i < calculationResult.measures.length; i++) {
                if (model.isQuotaSecurityMeasure(calculationResult.measures[i].sid) &&
                        calculationResult.measures[i].sid + "" !== calculationInput.selectedQuotaSecurity){
                    continue;
                }
                model.calculationMeasures.push(calculationResult.measures[i]);
            }
        }
    };

    model.isQuotaSecurityMeasure = function(measureSid){
        if (model.quotaSecurities){
            var size = model.quotaSecurities.length;
            for (let i = 0; i < size; i++){
                if (model.quotaSecurities[i].measureSid === measureSid){
                    return true;
                }
            }
        }
        return false;
    };

    model.getAmounts = function(dutyItems) {
        var amounts = [];
        var i,j;
        var idx = 0;
        if (dutyItems === null) {
            return amounts;
        }
        for (let i = 0; i < dutyItems.length; i++) {
            var dutyItem = dutyItems[i];
            if (!dutyItem.amounts) {
                continue;
            }
            for (let j = 0; j < dutyItem.amounts.length; j++) {
                var amount = {};
                if (j === 0) {
                    amount.dutyItem = dutyItem;
                } else {
                    amount.dutyItem = null;
                }
                amount.amount = dutyItem.amounts[j];
                amounts[idx] = amount;
                idx++;
            }
        }
        return amounts;
    };

    model.getSecurityAmounts = function(dutyItems) {
        var amounts = [];
        var i,j;
        var idx = 0;
        if (dutyItems === null) {
            return amounts;
        }
        for (let i = 0; i < dutyItems.length; i++) {
            var dutyItem = dutyItems[i];
            if (dutyItem.securityType === "QUOTA" && dutyItem.measureSid + "" !== calculationInput.selectedQuotaSecurity){
                continue;
            }
            var amount = {};
            amount.dutyItem = dutyItem;
            amount.vatItem = dutyItem.vatSecurityItem;
            amounts[idx] = amount;
            idx++;
        }
        return amounts;
    };

    model.getAdditionalCodes = function () {
        return model.additionalCodes;
    };

    model.getOptionalAdditionalCodes = function () {
        return model.optionalAdditionalCodes;
    };

    model.getDocuments = function () {
        return model.documents;
    };

});



// WEBPACK FOOTER //
// ./app/taric/duties/shared/calculate-duties-model.js